'use client';

import React, { useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { Heart, Users, Star, Award, Globe, BookOpen, Target, CheckCircle, Trophy, AlertTriangle, Linkedin } from 'lucide-react';
import Header from '@/components/Header';
import JourneyCTA from '@/components/JourneyCTA';
import { IMAGE_NAMES, getImageUrl } from '@/config/imageConstants';
export default function AboutClient() {
  const [selectedLanguage, setSelectedLanguage] = useState<'english' | 'marathi'>('english');

  const stats = [
    { number: '100%', label: 'Verified Profiles', icon: Heart },
    { number: '95%', label: 'Success Rate', icon: Star },
    { number: '37', label: 'Years Experience', icon: Award },
  ];

  const englishContent = {
    brandStory: {
      title: "Brand Story & Who We Are?",
      content: "The 'MarathiVadhuVarSuchak.com' has been established by its parent company BhagyaVivah Matrimony for all caste brides and grooms belong to Marathi language speaking community only. This site is official and legal trademark of BhagyaVivah Matrimony company. Since 1990 we are helping Maharashtrian families’ offline and online (since 2014) to find the perfect Marathi match."
    },
    team: {
      title: "Our Team Information",
      members: [
        { 
          role: "Co-Founder", 
          name: "Sachin Khot",
          image: getImageUrl(IMAGE_NAMES.SACHIN_KHOT),
          linkedin: "https://www.linkedin.com/in/sachin-v-khot/",
          facebook: "https://facebook.com/sachin-khot",
          instagram: "https://instagram.com/sachin-khot",
          twitter: "https://twitter.com/sachin-khot"
        },
        { 
          role: "Co-Founder & CTO", 
          name: "Mangesh Narayankar",
          image: getImageUrl(IMAGE_NAMES.MANGESH_NARAYANKAR),
          linkedin: "https://www.linkedin.com/in/mangesh-narayankar/",
          facebook: "https://facebook.com/mangesh-narayankar",
          instagram: "https://instagram.com/mangesh-narayankar",
          twitter: "https://twitter.com/mangesh-narayankar"
        },
        { 
          role: "Managing Partner", 
          name: "Nitin Khot",
          image: getImageUrl(IMAGE_NAMES.NITIN_KHOT),
          linkedin: "",
          facebook: "",
          instagram: "",
          twitter: ""
        },
        { 
          role: "Operations Specialist", 
          name: "Yogita Khot",
          image: getImageUrl(IMAGE_NAMES.YOGITA_KHOT),
          linkedin: "",
          facebook: "https://facebook.com/yogita-khot",
          instagram: "https://instagram.com/yogita-khot",
          twitter: "https://twitter.com/yogita-khot"
        },
        { 
          role: "Support Expert", 
          name: "Sneha Hotkar",
          image: getImageUrl(IMAGE_NAMES.SNEHA_HOTKAR),
          linkedin: "",
          facebook: "https://facebook.com/sneha-hotkar",
          instagram: "https://instagram.com/sneha-hotkar",
          twitter: "https://twitter.com/sneha-hotkar"
        }
      ]
    },
    problemSolution: {
      title: "Problem Vs Solutions: Why providing dedicated matrimony services for Marathi community",
      content: "Due to the extremely fast-paced lifestyle nowadays and the growing difference in birth rates between males and females according to the census, finding a suitable match for marriage is becoming really tough. Also, the increasing busyness in jobs or careers among the youth is causing delays in decisions about marriage, which adds to parents' troubles. Considering the huge challenges in arranging marriages for brides and grooms in the Marathi community, the 'Marathi Vadhu Var Suchak' Kendra Mumbai has been established. Similarly, the lifestyle of youngsters due to their jobs has created difficulties in arranging marriages, and increasing social distance, as well as the increasing level of education among boys and girls, are also raising expectations about partners. As a result, parents' concerns are also increasing day by day. Also, horoscopes and Nadi Dosh conditions is causing more delay in marriage. The 'Marathi Vadhu Var Suchak' Kendra regularly organizes Melava for the Marathi brides and grooms. In today's fast-paced lifestyle, it's becoming difficult for brides and grooms to visit the 'Marathi Vadhu Var Suchak' Kendra in person, so we have also provided online services. For this, the official website of the 'Marathi Vadhu Var Suchak' https://www.MarathiVadhuVarSuchak.com has been launched, where registered brides and grooms and their parents can search information about suitable matches along with photos. Also, for the convenience of members, 'Marathi Vadhu Var Suchak' mobile app also launched. If the Marathi community members have any specific suggestions or feedback regarding the functioning of the 'Marathi Vadhu Var Suchak' Kendra in Mumbai, they should definitely inform our Mandal through the feedback form online. Helpful suggestions from the members will certainly be included in the 'Marathi Vadhu Var Suchak' Kendra's activities."
    },
    vision: {
      title: "Our Vision",
      content: "The vision of MarathiVadhuVarSuchak.com is to provide a trusted Marathi matrimony platform for all Marathi brides and grooms, where every Marathi household's bride and groom can choose their suitable life partner. MarathiVadhuVarSuchak.com focuses on personalized matchmaking for each Marathi bride and groom and aims to build trust within Marathi families. It's every Marathi family's wish for their children to find the right match, and we are all about fulfilling those hopes and expectations."
    },
    mission: {
      title: "Our Mission",
      content: "The mission of MarathiVadhuVarSuchak.com is to create an identity as a trustworthy and personalized matchmaking service for every Marathi-speaking bride and groom and their parents. Our aim is to provide a best online and offline platform for Marathi brides and grooms residing both in Maharashtra and abroad to find compatible partners, while focusing on how to transform every Marathi parent's concern into trust."
    },
    values: {
      title: "Brand Values",
      content: "Our core values emphasize excellent reliable service and integrity. In the current fast-paced lifestyle, the process of arranging marriages has become extremely complicated and difficult. So, we focus more on maintaining reliability and authenticity in our matrimony service. Because this reliability and authenticity will strengthen our trust in every Marathi family."
    },
    achievements: {
      title: "Our Achievements",
      content: "Since last 37 years we are providing successful offline matchmaking & online service (Since 2014) to many local Marathi communities. Now dedicated service for Marathi Vadhu Var is available through our platform MarathiVadhuVarSuchak.com site for all caste Marathi families."
    }
  };

  const marathiContent = {
    brandStory: {
      title: '"मराठी वधू वर सूचक डॉट कॉम" बद्दल',
      content: '"MarathiVadhuVarSuchak.com" ही मराठी कम्युनिटी साइट भाग्यविवाह मॅट्रिमनी कंपनीद्वारे स्थापन करण्यात आली आहे, जी केवळ मराठी भाषिक समाजातील सर्व जातीय वधू-वरांना मॅचमेकिंग सेवा पुरवते. ही साइट भाग्यविवाह मॅट्रिमनी कंपनीची अधिकृत आणि कायदेशीर ट्रेडमार्क आहे. 1990 पासून आम्ही महाराष्ट्रीयन कुटुंबांना ऑफलाइन आणि 2014 पासून ऑनलाइन मॅचमेकिंग सेवा देत आहोत.'
    },
    team: {
      title: "आमची टीम",
      members: [
        { 
          role: "को-फाउंडर", 
          name: "सचिन खोत",
          image: getImageUrl(IMAGE_NAMES.SACHIN_KHOT),
          linkedin: "https://www.linkedin.com/in/sachin-v-khot/",
          facebook: "https://facebook.com/sachin-khot",
          instagram: "https://instagram.com/sachin-khot",
          twitter: "https://twitter.com/sachin-khot"
        },
        { 
          role: "को-फाउंडर आणि सीटीओ", 
          name: "मंगेश नारायणकर",
          image: getImageUrl(IMAGE_NAMES.MANGESH_NARAYANKAR),
          linkedin: "https://www.linkedin.com/in/mangesh-narayankar/",
          facebook: "https://facebook.com/mangesh-narayankar",
          instagram: "https://instagram.com/mangesh-narayankar",
          twitter: "https://twitter.com/mangesh-narayankar"
        },
        { 
          role: "मॅनेजिंग पार्टनर", 
          name: "नितीन खोत",
          image: getImageUrl(IMAGE_NAMES.NITIN_KHOT),
          linkedin: "",
          facebook: "",
          instagram: "",
          twitter: ""
        },
        { 
          role: "ऑपरेशन्स स्पेशलिस्ट", 
          name: "योगिता खोत",
          image: getImageUrl(IMAGE_NAMES.YOGITA_KHOT),
          linkedin: "",
          facebook: "https://facebook.com/yogita-khot",
          instagram: "https://instagram.com/yogita-khot",
          twitter: "https://twitter.com/yogita-khot"
        },
        { 
          role: "सपोर्ट एक्सपर्ट", 
          name: "स्नेहा होतकर",
          image: getImageUrl(IMAGE_NAMES.SNEHA_HOTKAR),
          linkedin: "",
          facebook: "https://facebook.com/sneha-hotkar",
          instagram: "https://instagram.com/sneha-hotkar",
          twitter: "https://twitter.com/sneha-hotkar"
        }
      ]
    },
    problemSolution: {
      title: "मराठी कुटुंबियांसाठी खास सेवा उपलब्ध करून देण्यामागील उद्देश",
      content: "एकूणच सध्याच्या अत्यंत वेगवान जीवनशैलीमुळे आणि जनगणनेनुसार मुली आणि मुलांमधील वाढत्या जन्मदरातील फरकामुळे एखादं स्थळं मिळणं अत्यंत कठीण होत चाललं आहे. तसेच, तरुण आणि तरुणींमधील नोकरी किंवा व्यवसायातील वाढत्या व्यस्तपणामुळे लग्नाचा निर्णय घेण्यास होतं असलेल्या दिरंगाईमुळे पालकांच्या अडचणी सुद्धा वाढत आहेत. मराठी समाजातील मुला-मुलींचे विवाह जमविण्यात येणाऱ्या प्रचंड अडचणी विचारात करून 'मराठी वधू-वर सूचक' या विवाह संस्थेची स्थापना भाग्यविवाह मॅट्रिमोनी कंपनीच्या वतीने करण्यात आली आहे. एकाबाजूला धकाधकीच्या नोकरी तसेच व्यवसायानिमित्त तरुण-तरुणींची लग्न जमविण्यात निर्माण झालेल्या अडचणी आणि त्यात मूळ गाव-शहराकडील भाऊबंद आणि नातेवाईक यांच्यासोबत कमी होत चाललेला संपर्क, तसेच मुला-मुलींमधील शिक्षणाचा वाढता दर्जा देखील जोडीदाराबद्दलच्या अपेक्षा उंचावत आहेत. त्यामुळे पालकांची चिंता देखील दिवसेंदिवस वाढत आहे. त्यात भर म्हणजे, जन्मकुंडलीचा आग्रह, वधू-वरांची नाडी एक असणे यासारख्या मागण्यांमुळे पालकांच्या अडचणी सुद्धा वाढत आहेत. 'मराठी वधू-वर सूचक' वतीने वेळोवेळो वधू-वरांचे परिचय मेळावे सुद्धा आयोजित केले जातात. सध्याच्या धावपळीच्या जीवनशैलीत वधू-वरांना प्रत्यक्ष 'मराठी वधू-वर सूचक' केंद्राला भेट देणे अवघड होत असल्याने संस्थेने ऑनलाईन सुविधा देखील उपलब्ध केल्या आहेत. त्यासाठी 'मराठी वधू-वर सूचक' केंद्राची अधिकृत वेब साईट https://www.MarathiVadhuVarSuchak.com सुरु करण्यात आली असून त्याद्वारे नोंदणी असलेल्या वधू-वरांना तसेच त्यांच्या पालकांना अनुरूप स्थळांची माहिती फोटोसहित मिळवता येऊ शकते. 'मराठी वधू-वर सूचक' केंद्र, मुंबई या समस्त मराठी समाजाच्या विवाह संस्थेच्या कामकाजाविषयी मराठी समाज बांधवांच्या काही खास सूचना किंवा अभिप्राय असल्यास आमच्या संस्थेला अवश्य कळवाव्यात. सभासदांच्या विधायक सूचनांचा निश्चितच मंडळाच्या कामकाजांत समावेश करण्यात येईल."
    },
    vision: {
      title: "आमचे व्हिजन",
      content: "मराठी वधू वर सूचक डॉटकॉमचे व्हिजन मराठी वधू वरांसाठी आणि त्याच्या पालकांसाठी एक विश्वसनीय मराठी मॅट्रिमोनी प्लॅटफॉर्म उपलब्ध करून देणे असून जिथे प्रत्येक मराठी घरातील वधू वरांना त्यांचा अनुरूप जीवनसाथी निवडता येईल. मराठी वधू वर सूचक डॉटकॉमवर प्रत्येक मराठी वधू वराच्या व्यक्तिशः मॅचमेकिंगवर भर देणे आणि मराठी कुटुंबांमध्ये विश्वसनीयता निर्माण करण्यावर लक्ष केंद्रित केले जाते. आपल्या मुला-मुलींना सुयोग्य अनुरूप जोडीदार मिळावा ही प्रत्येक मराठी कुटुंबातील पालकांची इच्छा असते आणि पालकांच्या त्याच इच्छा अपेक्षा पूर्ण करण्यावर आमचा भर असतो."
    },
    mission: {
      title: "आमचे मिशन",
      content: "मराठी वधू वर सूचक डॉटकॉमचे मिशन हे प्रत्येक मराठी भाषिक वधू-वर आणि त्यांच्या पालकांच्या मनात एक विश्वसनीय आणि वैयक्तिक मॅचमेकिंग सेवा देणारी मराठी वधू वर सूचक संस्था अशी ओळख निर्माण करणं आहे. आमचा उद्देश हा महाराष्ट्रासह देश-विदेशातील मराठी वधू-वरांना अनुरूप जोडीदार शोधण्यासाठी एक योग्य ऑनलाईन आणि ऑफलाईन प्लँटफॉर्म उपलब्ध करून देताना, प्रत्येक मराठी पालकांची चिंता विश्वसनीयताात कशी बदलता येईल अशी सेवा देण्यावर भर आहे."
    },
    values: {
      title: "आमची मूल्य",
      content: "आमच्या मूलभूत मूल्यांमध्ये उत्कृष्ट विश्वसनीय सेवा आणि प्रामाणिकता यावर भर असतो. सध्याच्या धावपळीच्या जीवनशैलीत लग्न जमवण्याची प्रक्रिया अत्यंत किचकट आणि अवघड झाली आहे. त्यामुळे सध्याच्या मॅट्रिमोनी सेवेत विश्वसनीयता आणि प्रामाणिकता जोपासण्यावर आम्ही अधिक लक्ष केंद्रित करतो. कारण, हीच विश्वसनीयता आणि प्रामाणिकता प्रत्येक मराठी कुटुंबात आमचं स्थान अधिक बळकट करेल."
    },
    achievements: {
      title: "आमची उपलब्धी",
      content: "आम्ही गेली ३७ वर्षे मराठी वधू-वरांना ऑफलाईन मॅचमेकिंग सेवा देत आहोत, तसेच २०१४ पासून ऑनलाईन सेवा देण्यात येतं आहे. तसेच आमचा ऑनलाईन प्लॅटफॉर्म MarathiVadhuVarSuchak.com साईटद्वारे सर्व जातीच्या मराठी वधू-वरांसाठी आणि त्यांच्या कुटुंबियांसाठी खास सेवा उपलब्ध करून दिली आहे."
    }
  };

  const currentContent = selectedLanguage === 'english' ? englishContent : marathiContent;


  return (
    <div className="min-h-screen bg-gray-50">
      {/* Transparent Header */}
      <Header variant="transparent" />
      
      {/* Hero Section with Banner */}
      <section className="relative min-h-screen flex items-end overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <Image
            src={getImageUrl(IMAGE_NAMES.BANNER)}
            alt="About Marathi Vadhu Var Suchak Banner"
            fill
            className="object-cover"
            priority
            fetchPriority="high"
            unoptimized
          />
        </div>
        
        {/* Overlay for better text readability */}
        <div className="absolute inset-0 bg-black/40"></div>
        
        {/* Content */}
        <div className="container mx-auto px-4 relative z-10 mb-28 max-[599px]:mb-[7rem]">
          <div className="max-w-4xl">
            <h1 className="text-[3.2rem] hero-heading font-bold text-white mb-8" style={{ textShadow: '1px 1px 3px rgba(0, 0, 0, 0.2)', lineHeight: '1.16' }}>
              <div className="mb-4">मराठी वधू-वरांसाठी</div>
              <div>महाराष्ट्रातील अग्रणी विवाहसंस्था</div>
            </h1>
            <p className="text-xl text-white/90 mb-8 max-w-2xl max-[599px]:hidden" style={{ textShadow: '1px 1px 2px rgba(0, 0, 0, 0.3)' }}>
              We are a leading Marathi matrimony platform, dedicated to help Marathi Vadhu Var to find Anuroop Jodidar while preserving Marathi cultural values and traditions.
            </p>
            <Link 
              href="/register"
              className="bg-primary-600 hover:bg-primary-700 text-white px-8 py-4 rounded-full font-medium text-lg tracking-wide transition-all duration-300 transform hover:-translate-y-1 shadow-lg inline-block"
            >
              Register Now in 2 minutes
            </Link>
          </div>
        </div>
      </section>

      {/* Language Switch Section */}
      <section className="py-8 bg-white border-b">
        <div className="container mx-auto px-4">
          <div className="flex justify-center gap-4">
            <button
              onClick={() => setSelectedLanguage('english')}
              className={`px-6 py-3 rounded-lg font-medium transition-all duration-200 flex items-center gap-2 ${
                selectedLanguage === 'english'
                  ? 'bg-primary-600 text-white shadow-lg'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              <Globe className="w-5 h-5" />
              English
            </button>
            <button
              onClick={() => setSelectedLanguage('marathi')}
              className={`px-6 py-3 rounded-lg font-medium transition-all duration-200 flex items-center gap-2 ${
                selectedLanguage === 'marathi'
                  ? 'bg-primary-600 text-white shadow-lg'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              <Globe className="w-5 h-5" />
              मराठी
            </button>
          </div>
        </div>
      </section>

      {/* Brand Story Section */}
      <section className="py-20 bg-gradient-to-br from-primary-50 via-white to-secondary-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center px-4 py-2 bg-primary-100 text-primary-700 rounded-full text-sm font-medium mb-6">
              <BookOpen className="w-4 h-4 mr-2" />
              Our Foundation
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              {currentContent.brandStory.title}
            </h2>
            <div className="max-w-4xl mx-auto">
              <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
                <p className="text-lg text-gray-700 leading-relaxed">
                  {currentContent.brandStory.content}
                  </p>
                </div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center px-4 py-2 bg-secondary-100 text-secondary-700 rounded-full text-sm font-medium mb-6">
              <Users className="w-4 h-4 mr-2" />
              Leadership Team
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              {currentContent.team.title}
            </h2>
                </div>
                
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {currentContent.team.members.map((member, index) => (
              <div key={index} className="group bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 overflow-hidden">
                {/* Image with Social Media Overlay */}
                <div className="relative w-full aspect-[4/5] overflow-hidden">
                  <Image
                    src={member.image}
                    alt={member.name}
                    width={400}
                    height={500}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    unoptimized
                  />
                  
                  {/* LinkedIn Overlay - Only show if LinkedIn URL exists */}
                  {member.linkedin && (
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4">
                      <div className="flex justify-center">
                        <a
                          href={member.linkedin}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex items-center text-white hover:text-blue-300 transition-colors text-sm"
                        >
                          <Linkedin className="w-4 h-4 mr-2" />
                          Connect on LinkedIn
                        </a>
                      </div>
                    </div>
                  )}
                </div>
                
                {/* Content */}
                <div className="p-6 text-left">
                  <h3 className="text-lg font-bold text-gray-900 mb-2">
                    {member.name}
                  </h3>
                  <p className="text-sm text-gray-600">
                    {member.role}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Problem & Solution Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              {selectedLanguage === 'english' ? 'Problems v/s Solutions' : 'समस्या विरुद्ध उपाय'}
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              {selectedLanguage === 'english' ? 'Understanding the unique challenges faced by Marathi families in finding suitable matches and how we provide dedicated solutions to address these concerns.' : 'मराठी कुटुंबांना योग्य जोडीदार शोधण्यात येणाऱ्या विशिष्ट आव्हानांचे आकलन आणि या चिंतांना सामोरे जाण्यासाठी आम्ही कसे समर्पित उपाय प्रदान करतो.'}
            </p>
          </div>
                
          <div className="grid lg:grid-cols-2 gap-8 items-stretch">
            {/* Problems */}
            <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden hover:shadow-xl transition-all duration-300">
              <div className="p-8">
                <div className="flex items-center mb-6">
                  <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mr-4">
                    <AlertTriangle className="w-6 h-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-1">
                      {selectedLanguage === 'english' ? 'Marriage Arrangements Are Becoming Extremely Difficult.' : 'विवाह व्यवस्था अत्यंत कठीण होत चालल्या आहेत.'}
                    </h3>
                    <p className="text-gray-600">
                      {selectedLanguage === 'english' ? 'Modern lifestyle challenges in finding suitable matches.' : 'योग्य जोडीदार शोधण्यात आधुनिक जीवनशैलीची आव्हाने.'}
                    </p>
                  </div>
                </div>
                
                <div className="bg-gray-50 rounded-xl p-6">
                  <h4 className="text-lg font-bold text-gray-900 mb-4">
                    {selectedLanguage === 'english' ? "What's Problem!" : 'काय समस्या आहे!'}
                  </h4>
                  <div className="space-y-4">
                    <div className="flex items-start">
                      <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                      <p className="text-gray-700">
                        {selectedLanguage === 'english' ? 'Fast-paced lifestyle making marriage arrangements extremely difficult' : 'वेगवान जीवनशैलीमुळे विवाह व्यवस्था अत्यंत कठीण होणे'}
                      </p>
                    </div>
                    <div className="border-t border-gray-200"></div>
                    <div className="flex items-start">
                      <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                      <p className="text-gray-700">
                        {selectedLanguage === 'english' ? 'Growing difference in birth rates between males and females' : 'मुला-मुलींमधील जन्मदरातील वाढता फरक'}
                      </p>
                    </div>
                    <div className="border-t border-gray-200"></div>
                    <div className="flex items-start">
                      <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                      <p className="text-gray-700">
                        {selectedLanguage === 'english' ? 'Increasing busyness in jobs causing delays in marriage decisions' : 'नोकरीत वाढत्या व्यस्तपणामुळे विवाह निर्णयात दिरंगाई'}
                      </p>
                    </div>
                    <div className="border-t border-gray-200"></div>
                    <div className="flex items-start">
                      <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                      <p className="text-gray-700">
                        {selectedLanguage === 'english' ? 'Reduced social connections with extended family and relatives' : 'विस्तारित कुटुंब आणि नातेवाईकांशी कमी होत चाललेले सामाजिक संबंध'}
                      </p>
                    </div>
                    <div className="border-t border-gray-200"></div>
                    <div className="flex items-start">
                      <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                      <p className="text-gray-700">
                        {selectedLanguage === 'english' ? 'Higher education levels raising partner expectations' : 'उच्च शिक्षणामुळे जोडीदाराबद्दलच्या अपेक्षा वाढणे'}
                      </p>
                    </div>
                    <div className="border-t border-gray-200"></div>
                    <div className="flex items-start">
                      <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                      <p className="text-gray-700">
                        {selectedLanguage === 'english' ? 'Horoscope and Nadi Dosh conditions causing additional delays' : 'जन्मकुंडली आणि नाडी दोषाच्या अटींमुळे अतिरिक्त दिरंगाई'}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
                
            {/* Solutions */}
            <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden hover:shadow-xl transition-all duration-300">
              <div className="p-8">
                <div className="flex items-center mb-6">
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-xl flex items-center justify-center mr-4">
                    <CheckCircle className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-1">
                      {selectedLanguage === 'english' ? 'We Provide Dedicated Solutions for Marathi Community.' : 'आम्ही मराठी समुदायासाठी समर्पित उपाय प्रदान करतो.'}
                    </h3>
                    <p className="text-gray-600">
                      {selectedLanguage === 'english' ? 'Comprehensive matrimony services tailored for Marathi families.' : 'मराठी कुटुंबांसाठी सानुकूलित व्यापक विवाह सेवा.'}
                    </p>
          </div>
        </div>
                
                <div className="bg-gray-50 rounded-xl p-6">
                  <h4 className="text-lg font-bold text-gray-900 mb-4">
                    {selectedLanguage === 'english' ? "What's Solution." : 'काय उपाय आहे.'}
                  </h4>
                  <div className="space-y-4">
                    <div className="flex items-start">
                      <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                      <p className="text-gray-700">
                        {selectedLanguage === 'english' ? 'Dedicated Marathi Vadhu Var Suchak Kendra Mumbai established' : 'समर्पित मराठी वधू वर सूचक केंद्र मुंबई स्थापन'}
                      </p>
                    </div>
                    <div className="border-t border-gray-200"></div>
                    <div className="flex items-start">
                      <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                      <p className="text-gray-700">
                        {selectedLanguage === 'english' ? 'Regular Melava events for Marathi brides and grooms' : 'मराठी वधू-वरांसाठी नियमित मेळावे'}
                      </p>
                    </div>
                    <div className="border-t border-gray-200"></div>
                    <div className="flex items-start">
                      <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                      <p className="text-gray-700">
                        {selectedLanguage === 'english' ? 'Online services for convenient access' : 'सोयीस्कर प्रवेशासाठी ऑनलाइन सेवा'}
                      </p>
                    </div>
                    <div className="border-t border-gray-200"></div>
                    <div className="flex items-start">
                      <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                      <p className="text-gray-700">
                        {selectedLanguage === 'english' ? 'Official website with photo-enabled profile search' : 'फोटो-सक्षम प्रोफाइल शोधासह अधिकृत वेबसाइट'}
                      </p>
                    </div>
                    <div className="border-t border-gray-200"></div>
                    <div className="flex items-start">
                      <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                      <p className="text-gray-700">
                        {selectedLanguage === 'english' ? 'Mobile app for member convenience' : 'सदस्यांच्या सोयीसाठी मोबाइल अॅप'}
            </p>
          </div>
                    <div className="border-t border-gray-200"></div>
                    <div className="flex items-start">
                      <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                      <p className="text-gray-700">
                        {selectedLanguage === 'english' ? 'Community feedback integration for continuous improvement' : 'सतत सुधारणेसाठी समुदाय अभिप्राय एकीकरण'}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision, Mission, Values, Achievements Grid */}
      <section className="py-20 bg-gradient-to-br from-white via-gray-50 to-primary-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-8">
            
            {/* Vision Card */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 group">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4 group-hover:scale-110 transition-transform duration-300">
                  <Target className="w-6 h-6 text-blue-600" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 group-hover:text-blue-600 transition-colors">
                  {currentContent.vision.title}
                </h3>
              </div>
              <div className="space-y-4">
                <p className="text-gray-700 leading-relaxed">
                  {currentContent.vision.content}
                </p>
              </div>
        </div>

            {/* Mission Card */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 group">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4 group-hover:scale-110 transition-transform duration-300">
                  <CheckCircle className="w-6 h-6 text-green-600" />
          </div>
                <h3 className="text-2xl font-bold text-gray-900 group-hover:text-green-600 transition-colors">
                  {currentContent.mission.title}
                  </h3>
              </div>
              <div className="space-y-4">
                <p className="text-gray-700 leading-relaxed">
                  {currentContent.mission.content}
                </p>
              </div>
            </div>

            {/* Values Card */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 group">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mr-4 group-hover:scale-110 transition-transform duration-300">
                  <Heart className="w-6 h-6 text-purple-600" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 group-hover:text-purple-600 transition-colors">
                  {currentContent.values.title}
                </h3>
              </div>
              <div className="space-y-4">
                <p className="text-gray-700 leading-relaxed">
                  {currentContent.values.content}
                </p>
              </div>
            </div>

            {/* Achievements Card */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 group">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mr-4 group-hover:scale-110 transition-transform duration-300">
                  <Trophy className="w-6 h-6 text-orange-600" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 group-hover:text-orange-600 transition-colors">
                  {currentContent.achievements.title}
                </h3>
              </div>
              <div className="space-y-4">
                <p className="text-gray-700 leading-relaxed">
                  {currentContent.achievements.content}
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>


      {/* Statistics */}
      <section className="py-20 bg-gradient-to-br from-primary-600 via-primary-700 to-secondary-600 relative overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 bg-black/10"></div>
        <div className="absolute top-0 left-0 w-full h-full">
          <div className="absolute top-10 left-10 w-20 h-20 bg-white/10 rounded-full"></div>
          <div className="absolute top-32 right-20 w-16 h-16 bg-white/10 rounded-full"></div>
          <div className="absolute bottom-20 left-1/4 w-12 h-12 bg-white/10 rounded-full"></div>
          <div className="absolute bottom-32 right-1/3 w-8 h-8 bg-white/10 rounded-full"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center px-4 py-2 bg-white/20 text-white rounded-full text-sm font-medium mb-6">
              <Trophy className="w-4 h-4 mr-2" />
              Our Impact
            </div>
            <h2 className="text-4xl font-bold text-white mb-6">
              Trusted by Marathi Families
            </h2>
            <p className="text-xl text-white/90 max-w-3xl mx-auto">
              Our success is measured by the happiness of the Marathi families we&apos;ve helped create
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            {stats.map((stat, index) => (
              <div key={index} className="group">
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-center hover:bg-white/20 transition-all duration-300 border border-white/20 hover:border-white/40">
                  <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                    <stat.icon className="w-8 h-8 text-white" />
                </div>
                  <div className="text-4xl font-bold text-white mb-3 group-hover:scale-105 transition-transform duration-300">
                    {stat.number}
                  </div>
                  <div className="text-white/90 font-medium text-lg">
                    {stat.label}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>



      {/* Contact CTA */}
      <JourneyCTA 
        title="Ready to Start Your Journey?"
        description="Discover meaningful connections through our trusted Marathi matrimony platform built with the Marathi community's values at heart"
        primaryButtonText="Register Now in 2 minutes"
        primaryButtonLink="/register"
      />
    </div>
  );
}
